import MovieCard from '../MovieCard';
import { MovieListType } from '../../../types';
import MovieListingSkeleton from '../MovieListingSkeleton';

const MovieList = ({ movies, listRef, isLoading }: MovieListType) => {
  return (
    <ul className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3'>
      {movies.map((movie, index) => (
        <MovieCard
          key={movie.id}
          id={movie.id}
          ref={index === movies.length - 1 ? listRef : null}
          title={movie.title}
          posterPath={movie.poster_path}
          overview={movie.overview}
          voteAverage={movie.vote_average}
          voteCount={movie.vote_count}
        />
      ))}
      {isLoading && <MovieListingSkeleton />}
    </ul>
  );
};

export default MovieList;
